import React from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import { Icon, VFText } from '@vfgroup-oneplatform/foundation/Components';
import {
  getThemeImages,
  useTheme,
  LightThemeColors,
} from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../../FrameworkTestKeys';

import styles from './HintItem.Styles';

const HintItem = ({ description }) => {
  const theme = useTheme() || LightThemeColors;
  const images = getThemeImages(theme.name);

  return (
    <View style={styles.hintViewStyle} testID={FrameworkTestKeys.BLOHintItemView}>
      <Icon
        name={images.ic_tick_solved}
        type="image"
        size={24}
        style={styles.hintIconStyle}
        testID={FrameworkTestKeys.BLOHintItemIcon}
      />
      <VFText
        i18nKey={description}
        style={styles.hintTextStyle(theme)}
        testKey={FrameworkTestKeys.BLOHintItemText}
      />
    </View>
  );
};

HintItem.propTypes = {
  description: PropTypes.string,
};

export default HintItem;
